export default "__VITE_ASSET__CoX5vxFi__"